import { NLS_KEYS, STRINGS_NLS, type NlsStringMap } from '../../strings_nls'

export const enStringsNls = Object.fromEntries(
  NLS_KEYS.map((key) => [key, STRINGS_NLS[key].text]),
) as NlsStringMap

export default enStringsNls
